/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pinned_MessageInputs */

const en_pinned_message = /** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinned`)
};

const es_pinned_message = /** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fijado`)
};

const fr_pinned_message = /** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Épinglé`)
};

const de_pinned_message = /** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angepinnt`)
};

const id_pinned_message = /** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disematkan`)
};

/** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */
const ja_pinned_message = en_pinned_message;

/** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */
const zh_pinned_message = en_pinned_message;

/** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */
const ar_pinned_message = en_pinned_message;

/** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */
const it_pinned_message = en_pinned_message;

/** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */
const ru_pinned_message = en_pinned_message;

/** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */
const pt_pinned_message = en_pinned_message;

/** @type {(inputs: Pinned_MessageInputs) => LocalizedString} */
const ko_pinned_message = en_pinned_message;

/**
* | output |
* | --- |
* | "Pinned" |
*
* @param {Pinned_MessageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pinned_message = /** @type {((inputs?: Pinned_MessageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pinned_MessageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pinned_message(inputs)
	if (locale === "es") return es_pinned_message(inputs)
	if (locale === "fr") return fr_pinned_message(inputs)
	if (locale === "de") return de_pinned_message(inputs)
	if (locale === "ja") return ja_pinned_message(inputs)
	if (locale === "zh") return zh_pinned_message(inputs)
	if (locale === "ar") return ar_pinned_message(inputs)
	if (locale === "id") return id_pinned_message(inputs)
	if (locale === "it") return it_pinned_message(inputs)
	if (locale === "ru") return ru_pinned_message(inputs)
	if (locale === "pt") return pt_pinned_message(inputs)
	return ko_pinned_message(inputs)
});